import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from './util/invalidateQuery';

const routesExchange: UpdatesConfig['Mutation'] = {
  routeCreate: (_: Data, __: Variables, cache: Cache) => invalidateQuery('routes', cache),
  routeDelete: (_: Data, __: Variables, cache: Cache) => invalidateQuery('routes', cache),
};

export default routesExchange;
